module.exports = __webpack_public_path__ + "static/media/shyam_baba.86cf898f.png";